import { renderContentFromMetadata } from '@jutro/uiconfig';
import { logout } from 'saga-cep-specific-components';
import CommonConstants from 'sg-common-constants';
import metadata from './SgCepFooter.metadata.json5';
import './SgCepFooter.messages';

function SgCepFooter() {
    const overrides = {
        contactUsLink: {
            href: CommonConstants.SAGA_LINKS.CONTACT_US
        },
        termsAndConditionsLink: {
            href: CommonConstants.SAGA_LINKS.TERMS_AND_CONDITIONS
        },
        cookiesLink: {
            href: CommonConstants.SAGA_LINKS.COOKIES_POLICY
        },
        privacyPolicyLink: {
            href: CommonConstants.SAGA_LINKS.PRIVACY_POLICY
        },
        bereavementServiceLink: {
            href: CommonConstants.SAGA_LINKS.BEREAVEMENT_SERVICE
        },
        insuranceSupportServiceLink: {
            href: CommonConstants.SAGA_LINKS.INS_SUPPORT_SERVICE
        }
    };
    const resolvers = {
        resolveCallbackMap: {
            logout: logout
        }
    };
    return renderContentFromMetadata(metadata.componentContent, overrides, resolvers);
}

export default SgCepFooter;
